<template>
    <div class="noAccess">
      <div class="main">
        <img src="../assets/noAccess.png" alt="" />
        <div class="left">
          <div class="tip-wrap">
          <p class="tip">{{ $t("list.butigongfuwu") }}</p>
          <p class="time-wrap">IP:{{ noAccessData.ip }}</p>
        </div>
          <div class="connectBtn" @click="refresh">
            {{ $t("version12.refresh") }}
          </div>
         <!--  <div class="customer" @click="goService">
            <icon-svg iconClass="customer" class="customer-icon"></icon-svg>
            <span class="val">{{ $t("views.kefu") }}</span>
          </div> -->
        </div>
      </div>    
      
      
      
    </div>
  </template>
  
  <script>
  import {state} from '@/store.js'
  export default {
    data() {
      return {};
    },
    // inject: ["contactCustom"],
  
    methods: {
      refresh() {
        //假如一开始进入页面noAccess还存在，就先刷线页面，假如恢复访问，那么noAceess就会置为false
        if (state.isUnderNoAccess) {
          window.location.reload();
        } else {
          this.$router.push("/index");
        }
      },
      goService() {
      //  this.contactCustom();
      },
    },
    computed:{
      noAccessData : ()=>state.noAccessData
    },
    created() {},
  };
  </script>
  
  <style lang="scss" scoped>
  .noAccess {
    display: flex;
    align-items: center;
    justify-content: center;
   // flex-direction: column;
    width: 100%;
    height: 100vh;
    background: #000;
    
  }
  img {
   
    display: inline-block;
    margin-right: 50px;
  }

  .main{
    width : 800px;
    display: flex;
    justify-content: center;
  }

  .tip-wrap {
    .tip {
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 10px;
      word-break: break-all;
      text-align: left;
      font-size: 16px;
    }
  }
  
  .time-wrap {
    margin-bottom: 30px;
    color:#717a8d;
    text-align: left;
    .label {
      line-height: 20px;
      color: #ffffff;
      display: block;
      text-align: left;
    }
    .time {
      display: block;
      text-align: left;
      line-height: 20px;
      color: #ffffff;
    }
  }
  .left{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  .connectBtn {
    height:50px;
    line-height: 50px;
    color: #fff;
    background: url("../assets/btn_bg.png") no-repeat center center;
    background-size: 100% 100%;
    margin-bottom: 20px;
    width : 166px;

    cursor: pointer;
  }
  
  .customer {
    .customer-icon {
      color: #e6c233;
      fill: #e6c233;
      font-size: 15px;
      margin-right: 5px;
    }
    .val {
      line-height: 20px;
      color: #e6c233;
    }
  }
  </style>
  